import { useState } from "react";
import styles from "./HeaderBar.module.css";
import HeaderUserAvatar from "../header-user-avatar/HeaderUserAvatar.tsx";
import HeaderLoginButton from "../header-login-button/HeaderLoginButton.tsx";
import {Link, NavLink} from "react-router-dom";
import { useSelector } from 'react-redux';
import type { RootState } from '../../../store/store';

function HeaderBar() {
    const user = useSelector((state: RootState) => state.user.user);
    const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);
    const [open, setOpen] = useState(false);

    return (
        <nav className={`${styles.navbar} navbar navbar-expand-lg navbar-light`}>
            <div className="container">
                <Link className={`${styles.navbarBrand} navbar-brand`} to="/">
                    <div className={styles.logo}>
                        <div className={styles.logoWordmark}>
                            <div className={styles.line1}>Code Labs</div>
                            <div className={styles.line2}>Venture.</div>
                        </div>
                    </div>
                </Link>
                <button className="navbar-toggler" type="button" aria-label="Toggle navigation" aria-expanded={open} onClick={() => setOpen(o => !o)}>
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse navbar-collapse ${open ? "show" : ""}`} id="navbarNav">
                    <ul className="navbar-nav ms-auto align-items-center" onClick={() => setOpen(false)}>
                        <li className="nav-item">
                            <NavLink to="/courses" className={({ isActive }) =>
                                isActive
                                    ? `${styles.navLink} ${styles.navLinkActive} nav-link`
                                    : `${styles.navLink} nav-link`}>
                                Courses
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/about" className={({ isActive }) =>
                                isActive
                                    ? `${styles.navLink} ${styles.navLinkActive} nav-link`
                                    : `${styles.navLink} nav-link`}>
                                About
                            </NavLink>
                        </li>

                        {isLoggedIn && (
                            <li className="nav-item">
                                <NavLink to="/courses-enrolled" className={({ isActive }) =>
                                    isActive
                                        ? `${styles.navLink} ${styles.navLinkActive} nav-link`
                                        : `${styles.navLink} nav-link`}>
                                    My Learning
                                </NavLink>
                            </li>
                        )}

                        <li className="nav-item ms-3">
                            {isLoggedIn ? (
                                <>
                                    <div className="d-none d-lg-block">
                                        <HeaderUserAvatar user_initials={user.user_initials} user_name={user.user_name} />
                                    </div>
                                    <NavLink to="/user-profile" className={({ isActive }) =>
                                        isActive
                                            ? `${styles.navLink} ${styles.navLinkActive} nav-link d-lg-none`
                                            : `${styles.navLink} nav-link d-lg-none`}>
                                        Profile
                                    </NavLink>
                                </>
                            ) : (
                                <>
                                    <div className="d-none d-lg-block">
                                        <HeaderLoginButton />
                                    </div>
                                    <NavLink to="/login" className={({ isActive }) =>
                                        isActive
                                            ? `${styles.navLink} ${styles.navLinkActive} nav-link d-lg-none`
                                            : `${styles.navLink} nav-link d-lg-none`}>
                                        Login
                                    </NavLink>
                                </>
                            )}
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default HeaderBar;